import { Deferred } from '@sama/js-core';
import { SubscriptionManager } from '@sama/rxjs-core';
import { EventTrackingValue } from '../../../../team-apis/core/event-tracking';

/**
 * The stages of a helper:
 *
 * 1. listening
 * 2. async step (unless canceled)
 * 3. complete (unless canceled)
 * 4. clean up (whether canceled or not - like a "finally")
 */
export abstract class AbstractToolHelper extends SubscriptionManager {
  completion: Promise<void>;
  hasFinishedListening = false;
  private completionDeferred = new Deferred<void>();

  constructor() {
    super();
    this.completion = this.completionDeferred.promise;
  }

  cancel(_eventTrackingValue?: EventTrackingValue) {
    this.unsubscribe();
    this.cleanUp();
    this.completionDeferred.resolve();
  }

  isActive() {
    return this.completionDeferred.isPending();
  }

  async stopListening(event?: MouseEvent) {
    event?.preventDefault();
    this.unsubscribe();
    this.hasFinishedListening = true;
    await this.performAsyncStep();

    if (this.isActive()) {
      this.complete();
      this.cleanUp();
      this.completionDeferred.resolve();
    }
  }

  protected async performAsyncStep() {}

  protected complete() {}

  protected cleanUp() {}

  abstract startListening(): void;
}
